import { getField, updateField } from 'vuex-map-fields';

export default {
    namespaced: true,

    state: {
        user: {
            Email: '',
            Password: '',
            PasswordConfirmation: '',
        },
    },

    getters: {
        getField,
    },

    actions: {
        login({ state }) {
            return axios.post('/api/login', state.user);
        },
        recover({ state }) {
            return axios.post('/api/recover', state.user);
        },
        activate({ state }, token) {
            return axios.post(`/api/activate/${token}`, state.user);
        },
        confirmHowToRentGuide() {
            return axios.put('/api/contacts/how-to-rent-guide/confirm');
        },
    },

    mutations: {
        updateField,
    },
};
